export default (
  {
    id,
    uuid,
    Etag,
    etag,
    tenantId,
    tenantUuid,

    ...driver
  }
) => {
  return {
    ...driver,

    id: id || uuid || null,
    uuid: uuid || id || null,
    Etag: Etag || etag || null,
    etag: etag || Etag || null,
    tenantId: tenantId || tenantUuid || null,
    tenantUuid: tenantUuid || tenantId || null
  }
}
